export default "__VITE_ASSET__CZfu1Gm1__"